import { Dialog } from "@mui/material";
import styled from 'styled-components';
import theme from '../../theme/theme';

export const StyledDialog = styled(Dialog)`
    .MuiPaper-root {
        min-width: 500px;
        width: 800px;
        background: white;
        border-radius: 40px;
        padding: 8px;
        border: 1px solid rgba(224, 224, 224, 1);
    }
`;

export const ModalHeader = styled.h3`
    font-family: 'Manrope', sans-serif;
    padding: 16px 24px;
    font-size: 1.25rem;
    font-weight: 600;
    margin: 0;
    text-align: left;
    color: ${theme.palette.primary.main};
`;

export const ModalBody = styled.div`
    font-family: 'Manrope', sans-serif;
    padding: 40px 48px !important;
    display: flex;
    flex-direction: column;
    gap: 20px;
`;

export const ModalFooter = styled.div`
    font-family: 'Manrope', sans-serif;
    display: flex;
    justify-content: flex-end;
    gap: 8px;
    padding: 20px 24px !important;
`;

export const Input = styled.input`
    display: none;
    @media (max-width: 600px) {
        input {
            padding-left: 0;
        }
    }
`;

export const CustomFileButton = styled.button`
    background: ${theme.palette.primary.main};
    color: white;
    border: none;
    border-radius: 16px;
    padding: 12px 24px;
    font-weight: 600;
    cursor: pointer;
    transition: background 0.2s ease;
    font-family: 'Manrope', sans-serif;
    font-size: 16px;
    margin-top: 16px;

    &:hover {
        background: #152033;
    }

    &:disabled {
        background: rgba(29, 42, 65, 0.5);
        cursor: not-allowed;
    }
`;

export const DropZone = styled.div<{ $isDraggingOver: boolean }>`
    border: 2px dashed ${(props) => (props.$isDraggingOver ? 'rgba(4, 47, 152, 0.5)' : '#dde2e6')};
    border-radius: 8px;
    background: ${(props) => (props.$isDraggingOver ? 'rgba(4, 47, 152, 0.05)' : '#ffffff')};
    padding: 32px;
    text-align: center;
    transition: all 0.2s ease-in-out;
    margin-bottom: 16px;
    cursor: pointer;

    p {
        margin: 0;
        color: ${(props) => (props.$isDraggingOver ? 'rgba(4, 47, 152, 0.8)' : '#666')};
    }
`;
